<template>
  <span>
    <b-modal v-model="showDeleteModal"
      title="Deseja remover o item?"
      class="modal-primary"
      @ok="remove">
        Ao confirmar essa ação o item não poderá ser recuperado. Deseja remover o item <b>{{ instance.representation || '' }}</b>?
    </b-modal>

    <i :class='icon' v-b-tooltip.hover :title="label" @click.stop.prevent="showDeleteModal = true"></i>
  </span>
</template>

<script>
export default {
  props: {
    entity: {
      type: Object,
      required: true
    },

    http: {
      type: Object,
      required: true
    },

    instance: {
      type: Object,
      required: true
    },

    label: {
      type: String,
      default: 'Remover'
    },

    icon: {
      type: String,
      default: 'fa fa-trash-o'
    }
  },

  data () {
    return {
      processing: false,
      showDeleteModal: false
    }
  },
  methods: {
    remove () {
      const self = this
      self.processing = true
      this.$Progress.start()
      self.http.destroy(self.instance.id)
        .then((res) => {
          self.processing = false
          this.$Progress.finish()
          self.$toasted.success('Remoção realizada com sucesso')
          self.$emit('refresh')
        })
        .catch(() => {
          self.processing = false
          this.$Progress.fail()
          self.$toasted.info('Houve um erro ao remover o item')
        })
    }
  }
}
</script>

<style lang="sass" scoped>
i
  cursor: pointer
  margin-right: 8px
</style>



// WEBPACK FOOTER //
// src/components/ui/DatatableElements/DeleteElement.vue